<template>
  <v-dialog v-model="show" max-width="300" persistent>
    <v-card>
      <v-card-title class="text-h6">Add Photo</v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12">
            <v-tooltip bottom :disabled="cameraAvailable !== false">
              <template #activator="{ on, attrs }">
                <span v-on="on" v-bind="attrs" style="display: block">
                  <v-btn
                    block
                    color="primary"
                    :disabled="cameraAvailable !== true"
                    :loading="cameraAvailable === null"
                    @click="onTakePhoto"
                  >
                    <v-icon left>mdi-camera</v-icon>
                    Take Photo
                  </v-btn>
                </span>
              </template>
              <span>Camera not available or permission denied</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-btn block color="secondary" @click="onUploadFile">
              <v-icon left>mdi-upload</v-icon>
              Upload File
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CameraFileDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // null = still checking, true = available, false = unavailable/denied
      cameraAvailable: null,
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(val) {
        if (!val) this.$emit("cancel");
      },
    },
  },
  watch: {
    showDialog(val) {
      if (val) {
        this.checkCameraAvailability();
      }
    },
  },
  methods: {
    async checkCameraAvailability() {
      this.cameraAvailable = null;
      try {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
          this.cameraAvailable = false;
          return;
        }
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasVideoDevice = devices.some((d) => d.kind === "videoinput");
        if (!hasVideoDevice) {
          this.cameraAvailable = false;
          return;
        }
        // If the Permissions API supports 'camera', check for an explicit denial.
        // Safari doesn't support this query so we fall back to assuming available.
        if (navigator.permissions) {
          try {
            const status = await navigator.permissions.query({ name: "camera" });
            this.cameraAvailable = status.state !== "denied";
          } catch {
            this.cameraAvailable = true;
          }
        } else {
          this.cameraAvailable = true;
        }
      } catch {
        this.cameraAvailable = false;
      }
    },
    onTakePhoto() {
      this.$emit("takePhoto");
    },
    onUploadFile() {
      this.$emit("uploadFile");
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
